import { useQuery } from '@tanstack/react-query';
import { useFlags } from 'launchdarkly-react-client-sdk';

import {
	type BarryConversation,
	searchBarryConversationsForUserAndBusiness,
} from '~api/common/barry/barry';
import type { ApiError } from '~types/api';
import { getApiErrorText } from '~utils/getApiErrorText';
import { callErrorToast } from '~utils/toasts';

interface BarrySearchResult {
	conversations: BarryConversation[];
	total: number;
}

export const useSearchBarryConversationsForUserAndBusiness = (
	query: string,
	enabled: boolean,
) => {
	const { barryMessenger } = useFlags();

	return useQuery<unknown, ApiError, BarrySearchResult>({
		queryKey: ['searchBarryConversationsForUserAndBusiness', query],
		queryFn: async () => {
			if (!query || !barryMessenger) {
				return null;
			}

			const { data } = await searchBarryConversationsForUserAndBusiness(query);
			return data as BarrySearchResult;
		},
		onError: (error) => {
			callErrorToast({
				content: getApiErrorText(
					error,
					'An error occurred while searching your conversations with Barry',
				),
			});
			return error;
		},
		enabled,
	});
};
